import React, { forwardRef, type Ref } from 'react';
import { Field } from '../field';
import { type BaseFieldProps } from './base-field-props';
import { useFieldProps } from '../../contexts/field-props-context';

interface BaseDescriptionProps {
  className?: string;
}

const BaseDescriptionRoot = <T extends BaseFieldProps>(
  props: BaseDescriptionProps,
  ref: Ref<HTMLDivElement>,
) => {
  const { description } = useFieldProps<T>();
  return <Field.Description ref={ref} {...props} description={description} />;
};

export const BaseDescription = forwardRef(
  BaseDescriptionRoot,
) as typeof BaseDescriptionRoot;
